import { APPOINTMENT_LAYOUT } from 'features/appointment/services/constants';
import appointmentSelectors from 'features/appointment/services/selectors';
import React, { memo } from 'react';
import CalendarTypeView from './Calendar/CalendarTypeView';
import ListLayout from './ListLayout';
import CalendarTableView from './Calendar/TableView';

function AppointmentLayout({ v2 }: { v2?: boolean }) {
    const layout = appointmentSelectors.getAppointmentLayout();
    if (layout === APPOINTMENT_LAYOUT.CALENDAR)
        return <CalendarTableView v2={v2} />;
    return <ListLayout v2={v2} />;
}

export default memo(AppointmentLayout);
